import Table from "components/Table2";
import { useFormikContext } from "formik";
import Quantity from "./comps/quantity";
import Product from "./comps/product";
import BasicButton from "components/BasicInputs/BasicButton";
import PlusIcon from "assets/icons/PlusIcon";
import shortid from "shortid";
import { BoxesIcon } from "assets/icons/BoxesIcon";

export default function MaterialsList() {
  const data = useFormikContext<MaterialFormulaData>();
  const v = data.values;

  return (
    <div>
      <div className="flex items-end gap-4 mb-10">
        <BoxesIcon />
        <span className="text-lg">انتخاب مواد اولیه</span>
      </div>
      <Table
        headers={[{ label: "کالا" }, { label: "مقدار(واحد اصلی)" }]}
        cols={[
          { Comp: Product, key: "productId" },
          { Comp: Quantity, key: "quantity", style: { width: 230 } },
        ]}
        bgColor="#fff"
        headerColor="#fff"
        rows={data.values.materialsRows}
        withBorder={true}
        tableBorder={false}
        noScroll
        onDelete={(row: MaterialsRow) => {
          const newRows = v.materialsRows?.filter((x) => x.ind !== row.ind);
          data.setFieldValue("materialsRows", newRows);
        }}
      />
      <BasicButton
        className="mt-4"
        onClick={() => {
          const newRows = [...(v.materialsRows || [])];
          newRows.push({ ind: shortid.generate() });
          data.setFieldValue("materialsRows", newRows);
        }}
      >
        <PlusIcon scale={0.7} />
        <span>افزودن مواد اولیه</span>
      </BasicButton>
    </div>
  );
}
